<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    persistent
    class="settings-button"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" icon>
        <v-icon medium>settings</v-icon>
      </v-btn>
    </template>
    <v-card v-if="notificationSettings" style="overflow: hidden;">
      <div class="body">
        <v-card-title class="title">
          <h1 class="title-text">通知設定</h1>
        </v-card-title>
        <v-card-title v-if="isHideRevenue === false">
          <h2>管理画面内通知</h2>
        </v-card-title>
        <v-card-text class="contents">
          <v-layout v-if="isHideRevenue === false">
            <v-flex class="secondary-title" xs3>
              <div>予算申請通知</div>
            </v-flex>
            <v-flex>
              <v-switch
                @change="
                  notificationSettings.screen.setAllRequestIsNotify($event)
                "
                v-model="isScreenRequestOpen"
              />
            </v-flex>
          </v-layout>
          <v-layout v-if="isScreenRequestOpen">
            <v-flex xs2>
              <v-checkbox
                v-model="
                  notificationSettings.screen.requestBudget.audit.isNotify
                "
                label="承認時"
              />
            </v-flex>
            <v-flex xs2>
              <v-checkbox
                v-model="
                  notificationSettings.screen.requestBudget.reject.isNotify
                "
                label="却下時"
              />
            </v-flex>
          </v-layout>
          <v-layout v-if="isHideRevenue === false">
            <v-flex class="secondary-title" xs3>
              <div>クリエイティブ審査通知</div>
            </v-flex>
            <v-flex>
              <v-switch
                @change="
                  notificationSettings.screen.setAllCreativeIsNotify($event)
                "
                v-model="isScreenCreativeOpen"
              />
            </v-flex>
          </v-layout>
          <v-layout v-if="isScreenCreativeOpen">
            <v-flex xs2>
              <v-checkbox
                v-model="
                  notificationSettings.screen.requestCreative.audit.isNotify
                "
                label="承認時"
              />
            </v-flex>
            <v-flex xs2>
              <v-checkbox
                v-model="
                  notificationSettings.screen.requestCreative.reject.isNotify
                "
                label="却下時"
              />
            </v-flex>
            <v-flex xs3>
              <v-checkbox
                v-model="
                  notificationSettings.screen.googleCreative.audit.isNotify
                "
                label="承認時 (Google)"
              />
            </v-flex>
            <v-flex xs3>
              <v-checkbox
                v-model="
                  notificationSettings.screen.googleCreative.reject.isNotify
                "
                label="却下時 (Google)"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-title>
          <h2>メール通知</h2>
        </v-card-title>
        <v-card-text class="contents">
          <v-layout v-if="isHideRevenue === false">
            <v-flex class="secondary-title" xs3>
              <div>予算申請情報</div>
            </v-flex>
            <v-flex>
              <v-switch
                @change="selectAllMailRequest($event)"
                v-model="isMailRequestOpen"
              />
            </v-flex>
          </v-layout>
          <template v-if="isMailRequestOpen">
            <v-layout>
              <v-flex xs2>
                <v-checkbox
                  v-model="
                    notificationSettings.email.requestBudget.audit.isNotify
                  "
                  label="承認時"
                />
              </v-flex>
              <v-flex xs2>
                <v-checkbox
                  v-model="
                    notificationSettings.email.requestBudget.reject.isNotify
                  "
                  label="却下時"
                />
              </v-flex>
            </v-layout>
            <p class="secondary-title">通知頻度</p>
            <v-radio-group
              v-model="notificationSettings.email.requestBudget.audit.frequency"
              :disabled="notificationSettings.email.isRequestEmpty"
              column
            >
              <v-radio label="毎時" value="hourly" />
              <v-radio label="1日1回" value="daily" />
            </v-radio-group>
          </template>
          <v-layout v-if="isHideRevenue === false">
            <v-flex class="secondary-title" xs3>
              <div>クリエイティブ審査情報</div>
            </v-flex>
            <v-flex>
              <v-switch
                @change="selectAllMailCreative($event)"
                v-model="isMailCreativeOpen"
              />
            </v-flex>
          </v-layout>
          <template v-if="isMailCreativeOpen">
            <v-layout wrap>
              <v-flex xs2>
                <v-checkbox
                  v-model="
                    notificationSettings.email.requestCreative.audit.isNotify
                  "
                  label="承認時"
                />
              </v-flex>
              <v-flex xs2>
                <v-checkbox
                  v-model="
                    notificationSettings.email.requestCreative.reject.isNotify
                  "
                  label="却下時"
                />
              </v-flex>
              <v-flex xs3>
                <v-checkbox
                  v-model="
                    notificationSettings.email.googleCreative.audit.isNotify
                  "
                  label="承認時 (Google)"
                />
              </v-flex>
              <v-flex xs3>
                <v-checkbox
                  v-model="
                    notificationSettings.email.googleCreative.reject.isNotify
                  "
                  label="却下時 (Google)"
                />
              </v-flex>
            </v-layout>
            <p class="secondary-title">通知頻度</p>
            <v-radio-group
              v-model="
                notificationSettings.email.requestCreative.audit.frequency
              "
              :disabled="notificationSettings.email.isCreativeEmpty"
              column
            >
              <v-radio label="毎時" value="hourly" />
              <v-radio label="1日1回" value="daily" />
            </v-radio-group>
          </template>
          <v-layout>
            <v-flex class="secondary-title" xs3>
              <p>システム情報</p>
            </v-flex>
            <v-flex>
              <v-switch v-model="notificationSettings.email.system.isNotify" />
            </v-flex>
          </v-layout>
        </v-card-text>
      </div>
      <v-layout class="footer">
        <v-spacer />
        <v-flex xs2>
          <v-btn @click="dialog = false">
            キャンセル
          </v-btn>
        </v-flex>
        <v-flex xs2>
          <v-btn @click="save()" color="primary">
            保存
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import { NotificationSettingClassFormModel } from '@/models/Notification/NotificationSettingClassForm'

export default {
  name: 'NotificationSettings',
  props: {
    isHideRevenue: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      dialog: false,
      notificationSettings: undefined,
      isScreenRequestOpen: false,
      isScreenCreativeOpen: false,
      isMailRequestOpen: false,
      isMailCreativeOpen: false,
    }
  },
  computed: {
    budgetRequest() {
      return [
        { label: '承認時', value: 'request_budget_audit' },
        { label: '却下時', value: 'request_budget_reject' },
      ]
    },
    creativeCheck() {
      return [
        { label: '承認時', value: 'request_creative_audit' },
        { label: '却下時', value: 'request_creative_reject' },
        { label: '承認時 (Google)', value: 'request_creative_google_audit' },
        { label: '却下時 (Google)', value: 'request_creative_google_reject' },
      ]
    },
  },
  watch: {
    'notificationSettings.email.requestBudget.audit.frequency'(val) {
      this.notificationSettings.email.requestBudget.reject.frequency = val
    },
    'notificationSettings.email.requestCreative.audit.frequency'(val) {
      this.notificationSettings.email.requestCreative.reject.frequency = val
      this.notificationSettings.email.googleCreative.audit.frequency = val
      this.notificationSettings.email.googleCreative.reject.frequency = val
    },
    async dialog(val) {
      if (val) {
        this.notificationSettings = await NotificationSettingClassFormModel.populate()
        this.isScreenRequestOpen = !this.notificationSettings.screen
          .isRequestEmpty
        this.isScreenCreativeOpen = !this.notificationSettings.screen
          .isCreativeEmpty
        this.isMailRequestOpen = !this.notificationSettings.email.isRequestEmpty
        this.isMailCreativeOpen = !this.notificationSettings.email
          .isCreativeEmpty
      }
    },
  },
  methods: {
    async save() {
      await this.notificationSettings.save()
      this.dialog = false
    },
    selectAllMailRequest(val) {
      this.notificationSettings.email.setAllRequestIsNotify(val)
      if (val) {
        this.notificationSettings.email.requestBudget.audit.frequency = 'daily'
        this.notificationSettings.email.requestBudget.reject.frequency = 'daily'
      }
    },
    selectAllMailCreative(val) {
      this.notificationSettings.email.setAllCreativeIsNotify(val)
      if (val) {
        this.notificationSettings.email.requestCreative.audit.frequency =
          'daily'
        this.notificationSettings.email.requestCreative.reject.frequency =
          'daily'
        this.notificationSettings.email.googleCreative.audit.frequency = 'daily'
        this.notificationSettings.email.googleCreative.reject.frequency =
          'daily'
      }
    },
  },
}
</script>

<style scoped lang="scss">
.settings-button {
  margin-left: -20px;
}
.title-text {
  margin-left: auto;
  margin-right: auto;
  margin-top: 2%;
}
.contents {
  margin-left: 20px;
}

.secondary-title {
  font-weight: bold;
  font-size: medium;
  display: flex;
  align-items: center;
}

.body {
  height: 80vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

.footer {
  bottom: 0;
  overflow: hidden;
}
</style>
